import React from 'react';
import logo from './logo.svg';
import './App.css';
import './Side.css';
import ReactPlayer from 'react-player';
import TopNavigation from './components/topnavigation';
import MainContent from './components/maincontent' ;






function App() {



  return(
  <div>


<TopNavigation/>









{/* <ReactPlayer controls url= "http://127.0.0.1:8000/media/1._What_Youll_Get_from_this_Course.mp4&Token=7f015ea101f49fc705194067912fba17c12dc3d8"
  /> */}
  
 </div>
  );
  
}



export default App;
